"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPinterest = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconPinterest = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "M12.002 3a9 9 0 0 0-3.679 17.217c-.045-.64-.052-1.505.131-2.272l1.086-4.6s-.27-.537-.27-1.335c0-1.25.725-2.182 1.628-2.182.766 0 1.138.576 1.138 1.266 0 .773-.492 1.926-.745 2.996-.21.895.451 1.623 1.333 1.623 1.599 0 2.676-2.054 2.676-4.487 0-1.848-1.245-3.234-3.513-3.234-2.56 0-4.157 1.91-4.157 4.04 0 .735.218 1.254.557 1.656.155.182.179.26.119.47-.041.155-.134.529-.171.68-.057.213-.228.291-.422.21-1.18-.482-1.728-1.771-1.728-3.223 0-2.399 2.022-5.271 6.032-5.271 3.223 0 5.34 2.332 5.34 4.834 0 3.309-1.838 5.783-4.553 5.783-.91 0-1.77-.492-2.061-1.05 0 0-.489 1.944-.594 2.32-.214.777-.676 1.557-1.035 2.088a9 9 0 0 0 2.884.471A9 9 0 0 0 21 12c0-4.971-4.027-9-8.998-9" })] })));
};
exports.IconPinterest = IconPinterest;
exports.IconPinterest.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconPinterest;
